import React from 'react';
import SouthIcon from '@mui/icons-material/South';
import InstructionsSeq1 from 'url:./images/InstructionsSeq1.png';
import InstructionsSeq2 from 'url:./images/InstructionsSeq2.png';
import InstructionsSeq3 from 'url:./images/InstructionsSeq3.png';
import InstructionsSeq4 from 'url:./images/InstructionsSeq4.png';
import InstructionsSeq5 from 'url:./images/InstructionsSeq5.png';
import InstructionsSeq6 from 'url:./images/InstructionsSeq6.png';
import DiamondExample from 'url:./images/DiamondExample.png';
import SquareExample from 'url:./images/SquareExample.png';
import TriangleExample from 'url:./images/TriangleExample.png';

export const Page1 = () => {
  return (
    <div className="page">
      <p>
        In Arithmeglyphs, you must work backwards from the third line to fill in the numbers that have been blanked out on the first two lines.
      </p>
      <img className="instructionsSeq5" src={InstructionsSeq5}/>
      <img className="instructionsSeq6" src={InstructionsSeq6}/>
      <img className="instructionsSeq4 page3seq4" src={InstructionsSeq4}/>
      <p>
        The shapes placed randomly around some of the blanks are <span className="italicText">operator glyphs</span>.
      </p>
      <p>
        Line 1's glyphs and hidden numbers together produced the hidden numbers on line 2. Line 2's glyphs and hidden numbers produced the final sequence of 4129 on line 3.
      </p>
    </div>
  );
};


export const Page2 = () => {
  return (
    <div className="page">
      <p>
        To learn how to work backwards, let's see how glyphs produce new number sequences going forwards.
      </p>
      <p>
        A puzzle starts with a random sequence like <span className="boldText">421</span>, and some glyphs are placed on it at random. Then we go left to right.
      </p>
      <p>
        If a digit has no glyph, that digit carries over to the next sequence unchanged.
      </p>

      <div className="operatorReferenceContainer">
        <img className="squareExample" src={SquareExample} />
        <p className="referenceText">Square this digit</p>
      </div>

      <div className="operatorReferenceContainer">
        <img className="triangleExample" src={TriangleExample} />
        <p className="referenceText">Multiply this digit by 3</p>
      </div>

      <img className="instructionsSeq1" src={InstructionsSeq1}/>
      <SouthIcon className="downwardArrow"/>
      <img className="instructionsSeq2" src={InstructionsSeq2}/>

      <br/>
      <p>Only individual digits matter, so that's not a 16 anymore - it's just a 1 and a 6 now.</p>
    </div>
  )
};


export const Page3 = () => {
  return (
    <div className="page">
      <p>
        Next, a new random pattern of glyphs is applied to this second number sequence.
      </p>
      <p>A blue rectangle around multiple digits means that those operator results are added together before placing the resulting digits on the next line. <span className="boldText">6 + (2 × 3) = 12</span>.</p>

      <div className="operatorReferenceContainer">
        <img className="diamondExample" src={DiamondExample} />
        <p className="referenceText">Multiply this digit by 4</p>
      </div>

      <img className="instructionsSeq1" src={InstructionsSeq1}/>
      <SouthIcon className="downwardArrow"/>
      <img className="instructionsSeq3" src={InstructionsSeq3}/>
      <SouthIcon className="downwardArrow"/>
      <img className="instructionsSeq4" src={InstructionsSeq4}/>
    </div>
  );
};

export const Page4 = () => {
  return (
    <div className="page">
      <p>Finally, the digits of the first two sequences are erased,
        leaving only the glyph pattern and the third number sequence. <br/> This is what you're given.</p>
      <img className="instructionsSeq5" src={InstructionsSeq5}/>
      <img className="instructionsSeq6" src={InstructionsSeq6}/>
      <img className="instructionsSeq4 page3seq4" src={InstructionsSeq4}/>
      <p>To solve the puzzle, you must work backwards from the third line to
      reconstruct the original starting sequence.</p>
      <p>There are no 0s on the first line, no negative numbers at all, and only one solution. Good luck!</p>
    </div>
  );
};